<maj-toasts-container></maj-toasts-container>
<div id="printSection" class="rev-modern" #printSection></div>
<pms-iframe-container></pms-iframe-container>
@if (!agreementGateService.usingLegacyAgreementsScreen()) {
	<div>
		<router-outlet></router-outlet>
	</div>
}
